import { render, staticRenderFns } from "./NavFloatingMenu.vue?vue&type=template&id=4cf47aaa&"
import script from "./NavFloatingMenu.vue?vue&type=script&lang=js&"
export * from "./NavFloatingMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports